import { Formik } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { stepPaymentInfoFulfilled, submitReport } from '../../../actions/damageReportActions';
import { IDamageReportReducer } from '../../../reducers/damageReportReducer';
import { RootState } from '../../../store';
import { StyledErrorMessage } from '../../base/forms/formikFieldWrapper.styles';
import { WizardPageProps } from '../../wizard/wizard';
import { stepPaymentInfoSchema } from './stepPaymentInfo.schema';
import * as StyledStepPaymentInfo from './stepPaymentInfo.styles';
import StepPaymentInfoForm from './stepPaymentInfoForm';

interface Props extends WizardPageProps {}

const StepPaymentInfo: FC<Props> = ({ onPrevious, onSubmit }) => {
	const { t } = useTranslation('damageReport');
	const dispatch = useDispatch<any>();
	const damageReportReducer: IDamageReportReducer = useSelector((store: RootState) => store.damageReportReducer);
	const pageReducer = useSelector((store: RootState) => store.pageReducer);
	const [pageValues, setPageValues] = useState({});
	const { page } = pageReducer;
	const { stepPaymentInfo, submissionFailed, submissionLoading, submissionFulfilled, errorMessage } =
		damageReportReducer;

	const onStepPaymentInfoSubmit = (values, actions) => {
		const { SendEmailTo } = page.Values;
		dispatch(stepPaymentInfoFulfilled(values));
		dispatch(submitReport(SendEmailTo));
		// onSubmit(values);
		actions.setSubmitting(false);
		setPageValues(values);
	};

	const onStepPaymentInfoPrevious = values => {
		dispatch(stepPaymentInfoFulfilled(values));
		onPrevious();
	};
	if (submissionFulfilled) {
		onSubmit(pageValues);
	}

	return (
		<StyledStepPaymentInfo.Wrapper>
			<Formik
				initialValues={stepPaymentInfo}
				enableReinitialize
				validationSchema={stepPaymentInfoSchema}
				onSubmit={onStepPaymentInfoSubmit}>
				{({ values, setFieldTouched, setFieldValue, isValid, isSubmitting, errors }) => (
					<StepPaymentInfoForm
						values={values}
						errors={errors}
						onPrevious={v => onStepPaymentInfoPrevious(v)}
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						isSubmitting={submissionLoading || isSubmitting}
						isValid={isValid}
					/>
				)}
			</Formik>
			{submissionFailed ? (
				<StyledStepPaymentInfo.ErrorTextWrapper>
					<StyledErrorMessage>{t('error-heading')}</StyledErrorMessage>
					<StyledErrorMessage>{errorMessage}</StyledErrorMessage>
				</StyledStepPaymentInfo.ErrorTextWrapper>
			) : null}
		</StyledStepPaymentInfo.Wrapper>
	);
};

export default StepPaymentInfo;
